import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n';
import router from './router/index.js'
import './assets/css/reset.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import paginationComponents from "@/components/Pagination";
import './utils/adjustFontSize';
import noMoreClick from '@/directive/noMoreClick'
// 全局 防重复点击
Vue.directive('no-more-click', noMoreClick)
Vue.component('paginationComponents', paginationComponents)
Vue.use(VueI18n);
Vue.use(ElementUI);

Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  messages: {
     'zh': require('@/assets/lang/zh'),
     'en': require('@/assets/lang/en')
  }
})
new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
